export const getServiceProviderOptions = (orchidPro: OrchidPro) => {
  return [
    {
      value: "Author",
      label: "Author",
    },
    {
      value: "Clinician",
      label: "Clinician",
    },
    {
      value: "Coach",
      label: "Coach",
    },
    {
      value: `Dr. ${orchidPro.last_name}` || "Dr. Last_Name",
      label: `Dr. ${orchidPro.last_name}` || "Dr. Last_Name",
    },
    {
      value: orchidPro.first_name || "First Name",
      label: orchidPro.first_name || "First Name",
    },
    {
      value:
        orchidPro.preferred_first_name || "Orchid_Clinician_Preferred_Name",
      label:
        orchidPro.preferred_first_name || "Orchid_Clinician_Preferred_Name",
    },
    {
      value: "Physician",
      label: "Physician",
    },
    {
      value: "Provider",
      label: "Provider",
    },
    {
      value: "Therapist",
      label: "Therapist",
    },
  ];
};
